export default __webpack_public_path__ + "static/media/VANTEC20AARRAY.c37e5c62.png";